(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["softmorrow-cart-upsell"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('softmorrow-cart-upsell')) {
      customElements.define('softmorrow-cart-upsell', class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.checkout = document.querySelector('#checkout');
          if (!this.dialog || !this.checkout) return;
          this.checkout.addEventListener('click', event => {
            event.preventDefault();
            this.dialog.showModal();
          });
          this.querySelector('[data-upsell-close]').addEventListener('click', () => this.dialog.close());
          this.querySelector('[data-upsell-skip]').addEventListener('click', () => this.goToCheckout());
          this.querySelector('[data-upsell-add]').addEventListener('click', () => this.addAndCheckout());
          this.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', () => this.update()));
          this.update();
        }
        update() {
          const quantity = Number(this.querySelector('input[type="radio"]:checked').value);
          this.querySelectorAll('[data-upsell-color]').forEach((field, index) => field.hidden = index >= quantity);
        }
        goToCheckout() {
          window.location.assign(this.dataset.checkoutUrl);
        }
        async addAndCheckout() {
          const quantity = Number(this.querySelector('input[type="radio"]:checked').value);
          const selects = [...this.querySelectorAll('[data-upsell-color] select')].slice(0, quantity);
          const items = [...selects.reduce((grouped, select) => {
            const id = Number(select.value);
            grouped.set(id, { id, quantity: (grouped.get(id)?.quantity || 0) + 1 });
            return grouped;
          }, new Map()).values()];
          const button = this.querySelector('[data-upsell-add]');
          const error = this.querySelector('[data-upsell-error]');
          button.disabled = true;
          error.hidden = true;
          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) {
              const details = await response.json();
              throw new Error(details.description || 'Unable to add the hair clip. Please try again.');
            }
            this.goToCheckout();
          } catch (reason) {
            error.textContent = reason.message || 'Unable to add the hair clip. Please try again.';
            error.hidden = false;
            button.disabled = false;
          }
        }
      });
    }

  } catch(e) { console.error(e); }
})();
})();
